import { useGetDataMappingsQuery } from "../api/dataMapping/dataMappingApi";
import useGetSkus from "./useGetSkus";

function useMapping(simplySku: string) {
  const vid = simplySku.split("-")[0];
  // const { data, error, isFetching } = useGetDataMappingsQuery({
  //   vendorId: vid,
  //   search: simplySku,
  // }, {
  //   skip: !vid
  // });
  // console.log("data mapping data", data);
  // const mapping = data?.Items?.find(m => m.InternalSku === simplySku);
  const sku = useGetSkus(simplySku);

  const mp = sku.data.length > 0 ? sku.data[0] : null

  return { mapping: mp, isFetching: sku.isFetching };

  // function _useMapping(simplySku: string) {
    // const { data, error, isFetching } = useGetDataMappingsQuery({
    //   vendorId: simplySku.split("-")[0],
    //   search: simplySku,
    // });
    // const mapping = data?.Items?.find(m => m.InternalSku === simplySku);
    // return { mapping, error, isFetching };
  // }
  // return _useMapping;

}
export { useMapping };